import { render, staticRenderFns } from "./msw-dashboard-list-view.vue?vue&type=template&id=97b8aada&scoped=true&"
import script from "./msw-dashboard-list-view.vue?vue&type=script&lang=tsx&"
export * from "./msw-dashboard-list-view.vue?vue&type=script&lang=tsx&"
import style0 from "./msw-dashboard-list-view.vue?vue&type=style&index=0&id=97b8aada&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b8aada",
  null
  
)

export default component.exports